import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-sorting-list',
  templateUrl: './sorting-list.component.html',
  styleUrls: ['./sorting-list.component.scss'],
})
export class SortingListComponent {
  @Input() sortingOptions: { key: string; value: string }[] = [];
  @Input() selectedSortOption: string = '';
  @Input() isAscendingSorting: boolean = true;

  @Output() sortOptionSelected: EventEmitter<{ key: string; value: string }> = new EventEmitter<{
    key: string;
    value: string;
  }>();
  @Output() toggleSorting: EventEmitter<any> = new EventEmitter<any>();

  onSortOptionSelected(option: { key: string; value: string }) {
    this.sortOptionSelected.emit(option);
  }

  onToggleSorting() {
    this.toggleSorting.emit();
  }
}
